import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Pagination from '../pagination'
import Table from './table'
import Filters from './filters'

function Reconciliations(props) {
  const [showFilters, setShowFilters] = useState(false)
  const { page, per_page, order, filters } = props
  const filterButtonClass = 'btn btn-info filters' + ( _.isEmpty(filters) ? ' inactive' : '')

  const applyFilters = (value) => {
    setShowFilters(false)
    props.onApplyFilters(value)
  }

  const buildDownloadParams = () => {
    const sortName = Object.keys(order)[0]
    const sortOrder = Object.values(order)[0]
  
    const params = `no_pagination=true&order[${sortName}]=${sortOrder}`
    const filterParams = filters.filter(f => f.completed).map((f, i) => 
      `filters[${i}][type]=${f.type || 'and'}&filters[${i}][query]=${f.query}`
    ).join('&')
    return [params, filterParams].join('&')
  }

  return <div className={'reconciliations' + (props.loading ? ' isLoading' : '')}>
    { props.loading && <div className='animated-spinner' /> }
    <div className='reconciliations__title'>Reconciliations</div>
    <button className={filterButtonClass} onClick={() => setShowFilters(true)}>Filters</button>
    <a className='btn btn-default download' href={'/admins/reconciliations.csv?' + buildDownloadParams()}>
      Download CSV
    </a>
    { showFilters && 
      <Filters
        filters={filters}
        locations={props.locations}
        regions={props.regions}
        onClose={() => setShowFilters(false)}
        onApply={applyFilters}
      />
    }
    <Pagination 
      page={page} 
      perPage={per_page}
      sizes={[15,30,50,100]}
      totalCount={props.total_count}
      setPage={props.setPage}
      setPerPage={props.setPerPage}
    />
    <Table
      reconciliations={props.reconciliations}
      order={order}
      socketUrl={props.socketUrl}
      onOrder={props.onOrder}
      onCloseGame={props.onCloseGame}
      onUpdateGame={props.onUpdateGame}
      onRefreshGame={props.onRefreshGame}
      onUpdateFacilityPay={props.onUpdateFacilityPay}
      onLocationUpdate={props.onLocationUpdate}
    />
  </div>
}

Reconciliations.propTypes = {
  reconciliations: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  total_count: PropTypes.number,
  page: PropTypes.number,
  per_page: PropTypes.number,
  locations: PropTypes.array.isRequired,
  regions: PropTypes.array.isRequired,
  filters: PropTypes.array.isRequired,
  socketUrl: PropTypes.string.isRequired,
  setPage: PropTypes.func.isRequired,
  setPerPage: PropTypes.func.isRequired,
  onOrder: PropTypes.func.isRequired,
  onCloseGame: PropTypes.func.isRequired,
  onUpdateGame: PropTypes.func.isRequired,
  onRefreshGame: PropTypes.func.isRequired,
  onApplyFilters: PropTypes.func.isRequired,
}

export default Reconciliations
